import PropertyBidCard from "@/Components/PropertyBigCard"
import { isMobile } from "@/utils/utils"
import Modal from "@/Components/Modal"

interface PropertyBigCardModalProps {
  property: ICell
  onClose: () => void
}

const PropertyBigCardModal: React.FC<PropertyBigCardModalProps> = ({
  property,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-10  z-[100] flex items-center justify-center p-4 mobile:p-[6px]">
      <Modal
        className="relative"
        onClose={onClose}
        contentClassName={
          // The close button is a fixed 44px on phones while the modal's own
          // padding is in rem - which the halved root font size shrinks to a
          // quarter of the button. Phone paddings are therefore in px: just
          // enough gutter at the top to clear the button, and a thin frame
          // around the card so the whole thing fits a landscape phone's height.
          "px-6 md:px-8 pb-6 md:pb-8 pt-16 flex flex-col gap-4 " +
          "mobile:px-[12px] mobile:pb-[12px] mobile:pt-[58px] " +
          "mobile:max-h-[calc(100dvh-14px)] mobile:overflow-y-auto"
        }
      >
        <PropertyBidCard
          size={isMobile() ? "mobile-big" : "normal"}
          cell={property}
        />
      </Modal>
    </div>
  )
}

export default PropertyBigCardModal
